(function(angular){
	'use strict';

	angular
		.module('settingsModule')
		.controller('ManageSecuritySettingsController', [
			'SettingsFactory',
			ManageSecuritySettingsFunction
		]);

	function ManageSecuritySettingsFunction(
		SettingsFactory
	){
		var manageSecuritySettings = this;

		manageSecuritySettings.$onInit = function() {
			SettingsFactory.knownLoginDevices.get()
				.then(function(devices) {
					manageSecuritySettings.yourDevices = devices;
				});
		};
	}
})(window.angular);